import { mergeListItem } from "../helpers/listItemMerge";

const atualizarSolicitacoes = (state, solicitacoes) => {
    state.solicitacoes = solicitacoes;
}

const atualizarSolicitacao = (state, solicitacao) => {
    state.solicitacao = solicitacao;
}

const atualizarProdutosCotacao = (state, produtosSolicitacao) => {
    state.produtosSolicitacao = produtosSolicitacao;
}

const atualizarCarregamentoProdutosCotacao = (state, carregando) => {
    state.carregandoProdutosCotacao = carregando;
}

const addSolicitacao = (state, solicitacao) => {
    if (!solicitacao || solicitacao.id == null) return;

    state.solicitacoes.push(JSON.parse(JSON.stringify(solicitacao)));
}

const removeProdutoCotacao = (state, produto) => {
    const index = state.produtosSolicitacao.findIndex(p => p.id === produto.id);
    if (index !== -1) {
        state.produtosSolicitacao.splice(index, 1);
    }
}

const updateSolicitacao = (state, solicitacao) => {
    if (!solicitacao || solicitacao.id == null) return;

    const index = state.solicitacoes.findIndex(item => item.id === solicitacao.id);
    if (index >= 0) {
        state.solicitacoes.splice(index, 1, mergeListItem(state.solicitacoes[index], solicitacao));
    }
}


export default {
    atualizarSolicitacoes,
    atualizarSolicitacao,
    atualizarProdutosCotacao,
    atualizarCarregamentoProdutosCotacao,
    addSolicitacao,
    updateSolicitacao,
    removeProdutoCotacao,
}
